export const theme = {
  colors: {
    green: ["#F1F6F9", "#3A6351"],
    purple: ["#40394A", "#1C1427"],
    white: "#FFFFFF",
    mediumGray: "#DDDDDD",
  },
  font: {
    family: {
      primary: "Fascinate",
      secondary: "Montserrat",
    },
    sizes: {
      xsmall: "8rem",
      small: "1.6rem",
      medium: "2.4rem",
      large: "3.2rem",
      xlarge: "4.0rem",
      xxlarge: "4.8rem",
      huge: "5.6rem",
      xhuge: "6.4rem",
    },
  },
  spacings: {
    xsmall: "8rem",
    small: "1.6rem",
    medium: "2.4rem",
    large: "3.2rem",
    xlarge: "4.0rem",
    xxlarge: "4.8rem",
    huge: "5.6rem",
    xhuge: "6.4rem",
  },
};
